import React from "react";
import {
  Box,
  Button,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";

const formatDateTime = (value) =>
  value
    ? new Date(value).toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

const formatQuantity = (value) =>
  value === null || value === undefined ? "-" : Number(value).toLocaleString();

// ENB-603: what happened to the order, when and by whom (status changes and each receipt).
// History comes back with the order itself; onReceive shows the Receive Partial button.
const SupplyOrderHistoryTable = ({ history = [], onReceive }) => {
  return (
    <Paper elevation={3} sx={{ padding: 3 }} style={{ maxWidth: "750px", marginTop: "16px" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h13" style={{ color: "rgb(25,118,210)" }}>
          History / Notes
        </Typography>
        {onReceive && (
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<MoveToInboxIcon />}
            onClick={onReceive}
          >
            Receive Partial
          </Button>
        )}
      </Box>

      <Divider sx={{ my: 1 }} />
      <TableContainer>
        <Table size="small">
          <TableHead
            sx={{
              backgroundColor: (theme) => theme.palette.primary.main,
            }}
          >
            <TableRow>
              {["Date / Time", "User", "Status / Note", "Product", "Qty"].map((column) => (
                <TableCell key={column} sx={{ color: "white" }}>
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {history.map((entry, index) => (
              <TableRow key={index}>
                <TableCell>{formatDateTime(entry.createdAt)}</TableCell>
                <TableCell>{entry.createdBy}</TableCell>
                <TableCell>{entry.status}</TableCell>
                <TableCell>{entry.productName}</TableCell>
                <TableCell>{formatQuantity(entry.quantity)}</TableCell>
              </TableRow>
            ))}
            {history.length === 0 && (
              <TableRow>
                <TableCell colSpan={5}>
                  <Typography variant="body2" color="textSecondary">
                    No history recorded yet
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SupplyOrderHistoryTable;
